import { render, staticRenderFns } from "./TfacReportPage.vue?vue&type=template&id=7625cd1f&scoped=true"
import script from "./TfacReportPage.vue?vue&type=script&lang=js"
export * from "./TfacReportPage.vue?vue&type=script&lang=js"
import style0 from "./TfacReportPage.vue?vue&type=style&index=0&id=7625cd1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7625cd1f",
  null
  
)

export default component.exports